export default __webpack_public_path__ + "static/spitz-fonts-mobile-267d8c01fc870d085978f82736941c3d.jpg";